"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var StoriesDeckLinkWrapper = function StoriesDeckLinkWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      _classCallCheck(this, _class2);
      return _callSuper(this, _class2, arguments);
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "title",
      get: function get() {
        if (!this.hasAccess) {
          return 'Go Pro';
        } else if (!_state.AppUI.user.isMember) {
          return 'Start Deck';
        }
        return this.props.deck.name;
      }
    }, {
      key: "hasAccess",
      get: function get() {
        return _state.AppUI.user.isMember || this.props.deck && this.props.deck.openAccess;
      }
    }, {
      key: "inProgress",
      get: function get() {
        return !this.finished && this.hasAccess && this.props.userDeck && !this.props.userDeck.finished && this.progressCurrent > 0;
      }
    }, {
      key: "finished",
      get: function get() {
        return this.hasAccess && this.props.finished || this.props.userDeck && (this.props.userDeck.finished || this.props.userDeck.designateAsFinished);
      }
    }, {
      key: "borderColor",
      get: function get() {
        if (this.props.borderColor) {
          return this.props.borderColor;
        } else if (this.finished || !_state.AppUI.user.isMember && this.props.deck.openAccess) {
          return _constants.Theme.green;
        } else if (this.inProgress) {
          return _constants.Theme.orange;
        }
        return '#777777';
      }
    }, {
      key: "hasUserDeck",
      get: function get() {
        return (0, _utils.isPresent)(this.props.userDeck);
      }
    }, {
      key: "progressCurrent",
      get: function get() {
        if (this.props.progressCurrent) {
          return this.props.progressCurrent;
        } else if (this.finished) {
          return this.progressTotal;
        }
        return this.hasUserDeck ? this.props.userDeck.progressCurrent + 1 : 0;
      }
    }, {
      key: "progressTotal",
      get: function get() {
        if (this.props.progressTotal) {
          return this.props.progressTotal;
        } else if (this.props.deck) {
          return this.props.deck.cardsCount;
        }
        return 0;
      }
    }, {
      key: "showCrownIcon",
      get: function get() {
        return !_state.AppUI.user.isMember && !this.props.deck.openAccess;
      }
    }, {
      key: "onClick",
      value: function onClick() {
        if (this.hasAccess && this.props.treeNodeId && this.props.fromGrammarSection) {
          _state.AppUI.routeStore.routeToNamed('grammar.decks.show', {
            treeNodeId: this.props.treeNodeId,
            deckId: this.props.deck.id
          });
        } else if (this.hasAccess && this.props.treeNodeId) {
          _state.AppUI.routeStore.routeToNamed('tree_nodes.decks.show', {
            treeNodeId: this.props.treeNodeId,
            deckId: this.props.deck.id
          });
        } else if (this.hasAccess) {
          _state.AppUI.routeStore.routeToNamed('decks.show', {
            deckId: this.props.deck.id
          });
        } else {
          _state.AppUI.routeStore.routeToNamed('memberships.index');
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          title: this.title,
          hasAccess: this.hasAccess,
          inProgress: this.inProgress,
          finished: this.finished,
          borderColor: this.borderColor,
          hasUserDeck: this.hasUserDeck,
          progressCurrent: this.progressCurrent,
          progressTotal: this.progressTotal,
          showCrownIcon: this.showCrownIcon,
          onClick: this.onClick
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "title", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "title"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasAccess", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasAccess"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inProgress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "finished", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "finished"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "borderColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "borderColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasUserDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasUserDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "progressCurrent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "progressCurrent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "progressTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "progressTotal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showCrownIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showCrownIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _class2)) || _class;
};
StoriesDeckLinkWrapper.displayName = 'StoriesDeckLinkWrapper';
var _default = exports["default"] = StoriesDeckLinkWrapper;